import { forwardRef, type InputHTMLAttributes } from 'react';
import { cx } from './utils';
import { FieldError } from './FieldError';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
}

export const TextField = forwardRef<HTMLInputElement, Props>(
  ({ label, error, containerClassName, className, ...rest }, ref) => (
    <div className={containerClassName}>
      {label && <label className="lbl">{label}</label>}
      <input
        ref={ref}
        {...rest}
        className={cx('inp', error && 'inp-error', className)}
        aria-invalid={!!error}
      />
      <FieldError message={error} />
    </div>
  ),
);
TextField.displayName = 'TextField';
